import script from "./CommentBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentBox.vue?vue&type=script&setup=true&lang=ts"

import "./CommentBox.vue?vue&type=style&index=0&id=94464140&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94464140"]])

export default __exports__